<!-- סטטוס הפגישה as a pill in its color: the customer's meeting list, מעקב פגישות, the timeline.
     status = a planup_meeting_status row, or statusId = its id (looked up in the store - a hidden one too).
     A status that asks for a new date carries the round arrow; clickable = the pill opens a picker (a
     chevron after the name). -->
<template>
    <span v-if="actualStatus"
          class="meetingStatusPill"
          :class="{ meetingStatusPillClickable: clickable }"
          :style="pillStyle">
        <i v-if="actualStatus.needsReschedule"
           class="fa-solid fa-rotate-right meetingStatusPillIcon"></i>
        <span>{{ actualStatus.name }}</span>
        <i v-if="clickable"
           class="fa-solid fa-chevron-down meetingStatusPillChevron"></i>
    </span>
    <span v-else-if="clickable"
          class="meetingStatusPill meetingStatusPillEmpty meetingStatusPillClickable">
        <span>{{ emptyText }}</span>
        <i class="fa-solid fa-chevron-down meetingStatusPillChevron"></i>
    </span>
</template>

<script>
import { inkOf, tintOf } from '../../services/calendar/calendar-colors';

export default {
    name: 'MeetingStatusPill',

    props: {
        status: { type: Object, default: null },
        statusId: { type: [Number, String], default: null },
        clickable: { type: Boolean, default: false },
        emptyText: { type: String, default: 'סמנו סטטוס' },
    },

    computed: {
        actualStatus() {
            if (this.status)
                return this.status;
            return this.statusId ? this.$handlers.meetingHandler.statusOf({ meetingStatusId: this.statusId }) : null;
        },

        pillStyle() {
            let color = this.$handlers.meetingHandler.statusColor(this.actualStatus);
            return { color: inkOf(color), background: tintOf(color, 0.12), borderColor: tintOf(color, 0.35) };
        },
    },
};
</script>

<style>
.meetingStatusPill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 1px 10px;
    border: 1px solid transparent;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
}

.meetingStatusPill.meetingStatusPillEmpty {
    color: #8a8f9c;
    background: #fff;
    border-color: #dcdfe6;
    border-style: dashed;
    font-weight: normal;
}

.meetingStatusPill.meetingStatusPillClickable {
    cursor: pointer;
}

.meetingStatusPill .meetingStatusPillIcon,
.meetingStatusPill .meetingStatusPillChevron {
    font-size: 10px;
    color: inherit !important;
}
</style>
